import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { Router } from '@angular/router';
import { KeysPipe } from '../../keyspipe.pipe';
import { CommonModule } from '@angular/common';
import { OnlyNumbersDirective,
         } from '../../../app/only-numbers.directive';
import { UsersService } from '../../services/users.service';
import { UserOtp } from '../../models/UserOtp';
import { EmailCode } from '../../models/EmailCode';
import { LoginServicesService } from '../../services/login-services.service';
import { LoginUserModel } from '../../models/loginUserModel';
import { AppService } from '../../services/app.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';

@Component({
    selector: 'app-auth-code-form-user',
    imports: [
        ReactiveFormsModule,
        FormsModule,
        CommonModule,
        KeysPipe,
        OnlyNumbersDirective,
        DialogModule,
        ButtonModule
    ],
    providers: [KeysPipe],
    templateUrl: './auth-code-form-user.component.html',
    styleUrl: './auth-code-form-user.component.scss'
})
export class AuthCodeFormComponentUser implements OnInit, OnDestroy {
  visible = true;
  isValidating = false;
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() validate: EventEmitter<any> = new EventEmitter<any>();
  @Input() phoneNumber!: string;
  @Input() email!: string;
  @Input() IsPhone!: boolean;
  @Input() clientNumber: number = 0;
  @Input() dialcode!: string;
  @Input() isRecovery: boolean = false;
  @Input() isDriver: boolean = false;
  @Input() isBlock: boolean = false;
  @Input() info: string ="";
  @Input() isActivate: boolean =false;
   @Input() isUnlink: boolean =false;
  OTPForm: FormGroup;
  otp!: string;
  otpError = false;
  otpMessage = '';
  msgType = '';
  msgError = '';

  enProceso = false;
  timer = 30;
  canResend = false;
  private timeoutId: any;
  private countdownId: any;
data!:LoginUserModel;
  constructor(
    private fb: FormBuilder,

    private router: Router,
    private keysPipe: KeysPipe,
    private service: UsersService,
    private loginService: LoginServicesService,
    private appServices: AppService
  ) {
    this.OTPForm = new FormGroup({});
    this.data = JSON.parse(localStorage.getItem('data')!); 
  }

  getFormControl(item: string | number): FormControl {
    return this.OTPForm?.controls[item] as FormControl;
  }
  ngOnInit(): void {
    for (let index = 0; index < 4; index++) {
      this.OTPForm.addControl(this.getControlName(index), new FormControl());
    }
    if (this.IsPhone) {
      this.msgType = 'mensaje vía whatsapp';
    } else {
      this.msgType = ' correo electrónico';
    }
    this.startTimerResend();
  }

  ngOnDestroy(): void {
    clearInterval(this.countdownId);
    clearTimeout(this.timeoutId);
  }

  ngAfterViewInit(): void {
    const containerItem = document.getElementById('c');
    if (containerItem) {
      containerItem.addEventListener('paste', (evt) => this.handlePaste(evt));
      const ele: any = containerItem.getElementsByClassName('otp-input')[0];
      if (ele && ele.focus) {
        ele.focus();
      }
    }
  }
  private getControlName(idx: string | number) {
    return 'ctrl_' + idx;
  }

  onKeyDown($event: any): any {
    const key = $event.keyCode || $event.charCode;
    if ([8, 9, 13, 27, 46, 37, 38, 39, 40].includes(key)) return true;
    if ((key === 65 || key === 67 || key === 86) && ($event.ctrlKey || $event.metaKey)) return true;
    if ((key >= 48 && key <= 57) || (key >= 96 && key <= 105)) return true;
    $event.preventDefault();
    return false;
  }

  ifKeyCode(event: { keyCode: any; charCode: any }, targetCode: number) {
    const key = event.keyCode || event.charCode;
    // tslint:disable-next-line: triple-equals
    return key == targetCode ? true : false;
  }

  onKeyUp($event: any, inputIdx: number) {
    const nextInputId = this.appendKey(`otp_${inputIdx + 1}`);
    const prevInputId = this.appendKey(`otp_${inputIdx - 1}`);
    if (this.ifRightArrow($event)) {
      this.setSelected(nextInputId);
      return;
    }
    if (this.ifLeftArrow($event)) {
      this.setSelected(prevInputId);
      return;
    }
    const isBackspace = this.ifBackspaceOrDelete($event);
    if (isBackspace && !$event.target.value) {
      this.setSelected(prevInputId);
      this.rebuildValue();
      return;
    }
    if (!$event.target.value) {
      return;
    }
    if (this.ifValidEntry($event)) {
      this.setSelected(nextInputId);
    }
    this.rebuildValue();
  }

  appendKey(id: string) {
    return id;
  }

  ifLeftArrow(event: any) {
    return this.ifKeyCode(event, 37);
  }

  ifRightArrow(event: any) {
    return this.ifKeyCode(event, 39);
  }

  ifBackspaceOrDelete(event: any) {
    return (
      event.key === 'Backspace' ||
      event.key === 'Delete' ||
      this.ifKeyCode(event, 8) ||
      this.ifKeyCode(event, 46)
    );
  }

  setSelected(eleId: string) {
    this.focusTo(eleId);

    const ele: any = document.getElementById(eleId);
    if (ele && ele.setSelectionRange) {
      setTimeout(() => {
        ele.setSelectionRange(0, 1);
      }, 0);
    }
  }

  ifValidEntry(event: { keyCode: number }) {
    const inp = String.fromCharCode(event.keyCode);
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    return (
      isMobile ||
      /[0-9]/.test(inp) ||
      (event.keyCode >= 96 && event.keyCode <= 105)
    );
  }

  focusTo(eleId: string) {
    const ele: any = document.getElementById(eleId);
    if (ele) {
      ele.focus();
    }
  }

  // method to set component value
  setValue(value: any) {
    if (isNaN(value)) {
      return;
    }
    this.OTPForm.reset();
    if (!value) {
      this.rebuildValue();
      return;
    }
    value = value.toString().replace(/\s/g, ''); // remove whitespace
    Array.from(value).forEach((c, idx) => {
      if (this.OTPForm.get(this.getControlName(idx))) {
        this.OTPForm.get(this.getControlName(idx))?.setValue(c);
      }
    });

    const containerItem = document.getElementById(`c`);
    var indexOfElementToFocus = value.length < 4 ? value.length : 3;
    let ele: any =
      containerItem?.getElementsByClassName('otp-input')[indexOfElementToFocus];
    if (ele && ele.focus) {
      ele.focus();
    }

    this.rebuildValue();
  }

  rebuildValue() {
    let val = '';
    this.keysPipe.transform(this.OTPForm.controls).forEach((k) => {
      if (this.OTPForm.controls[k].value) {
        val += this.OTPForm.controls[k].value;
      }
    });
    this.onOtpChange(val);
  }

  onOtpChange(otp: any) {
    this.otp = otp;
  }

  handlePaste(e: any) {
    // Get pasted data via clipboard API
    let clipboardData = e.clipboardData;
    if (clipboardData) {
      var pastedData = clipboardData.getData('Text');
    }
    // Stop data actually being pasted into div
    e.stopPropagation();
    e.preventDefault();
    if (!pastedData) {
      return;
    }
    this.setValue(pastedData);
  }

  hidePhone(phoneNumber: string, email: string) {
    if (this.IsPhone) {
      return (
        '*** *** **' +
        phoneNumber[phoneNumber.length - 2] +
        phoneNumber[phoneNumber.length - 1]
      );
    } else {
      const [name, domain] = email.split('@');
      return `${name[0]}${new Array(name.length).join('*')}@${domain}`;
      //return email;
    }
  }

  close() {
    this.closeModal.emit();
  }

  verifyOTP() {
    this.isValidating = true;
    if(this.isBlock){
      this.validateOTPBlock();
    }else if (this.isActivate) {
      if(this.isDriver){
        this.validateOTPActivate(3,this.phoneNumber);
      }else{
        this.validateOTPActivate(2,this.email);
      }
      
    }
    else if (this.isRecovery) {
      this.validateOTPRecovery();
    }
     else if (this.isUnlink) {
      this.validateOTPUnlink();
     } 
    else {
      if (this.IsPhone) {
        this.validateOTPCode(this.otp);
      } else {
        this.validateEmailCode(this.otp);
      }
     
    }
  }

  resend() {
    this.canResend = false;
    this.enProceso = true;
    this.otpMessage = "Enviando código...";
    this.otpError = false;
    this.startTimerResend();
    if (this.IsPhone) {
      this.resendOTPCode();
    } else {
      this.resendEmailCode();
    }
  }
  

  validateOTPCode(code: string) {    
    this.service.validateOTPCode(code, this.clientNumber,this.data.User_id,this.isDriver?4:3,this.phoneNumber).subscribe({
      next: (data: any) => {
        this.visible = true;
        this.isValidating = false;
        if (data.isSuccess) {
          this.msgError = '';
          this.validate.emit({
            success: true,
            code:code,
          });
        } else {
          this.visible = true;
        this.isValidating = false;
          this.msgError = data.message;
        }
      },
      error: (err: any) => {
        this.visible = true;
        this.isValidating = false;
        this.msgError = err;
      },
    });
  }

  validateEmailCode(code: string) {
    this.service.getEmailOTP(this.email,code,this.data.Client_number,this.data.User_id).subscribe({
      next: (data: any) => {
        this.visible = true;
        this.isValidating = false;
        if (data.isSuccess) {
          
            this.msgError = '';
            this.validate.emit(true);
          
        } else {
          this.msgError = data.message;
        }
      },
      error: (err: any) => {
        this.visible = true;
        this.isValidating = false;
        this.msgError = err;
      },
    });
  }

  resendOTPCode() {
    let userOtp = new UserOtp();
    userOtp.dialCode = this.dialcode;
    userOtp.phoneNumber = this.phoneNumber;
    userOtp.clientNumber = this.clientNumber;
    this.msgError = '';
    this.service.validatePhoneNumber(this.data.Client_number,this.phoneNumber,this.isDriver?4:3,userOtp.dialCode).subscribe({
      next: (data: any) => {
        this.enProceso = false;
        if (!data.isSuccess) {
          this.msgError = data.message;
          this.otpMessage = '';
        } else {
          this.msgError = '';
          this.otpMessage = 'Código reenviado por WhatsApp';
          this.otpError = false;
        }
      },
      error: (err: any) => {
        this.enProceso = false;
        this.otpMessage = '';
        this.msgError = err;
      },
    });
  }

  resendEmailCode() {
    let email = new EmailCode();
    email.email = this.email;
    email.clientNumber=this.data.Client_number;
    this.service.saveEmailOTP(email).subscribe({
      next: (data: any) => {
        this.enProceso = false;
        if (!data.isSuccess) {
          this.msgError = data.message;
          this.otpMessage = '';
        } else {
          this.msgError = '';
          this.otpMessage = 'Código reenviado por correo';
          this.otpError = false;
        }
      },
      error: (err: any) => {
        this.enProceso = false;
        this.otpMessage = '';
        this.msgError = err;
      },
    });
  }

  startTimerResend() {
    this.timer = 30;
    this.countdownId = setInterval(() => {
      this.timer--;

      if (this.timer <= 0) {
        clearInterval(this.countdownId);
        this.canResend = true;
      }
    }, 1000);
  }

  validateOTPRecovery() {
    this.loginService
      .generatePasswordRequest(this.clientNumber, this.otp)
      .subscribe({
        next: (resp: any) => {
          this.visible = true;
        this.isValidating = false;
          if (resp.isSuccess) {
            this.validate.emit({
              msg: resp.message,
              step: 2,
              success: true,
            });
          } else {
            this.msgError = resp.message;
          }
        },
        error: (err: any) => {
          console.error(err.error);
          this.visible = true;
        this.isValidating = false;
          this.msgError =
            'No se pudo generar la recuperación de contraseña, intenta de nuevo';
        },
      });
  }

   validateOTPUnlink() {
   
     //this.validateOTPActivate(3,this.email);
        this.appServices.unlinkDeviceEmail(this.clientNumber,this.info,true,this.otp,this.email,5)
      .subscribe({
        next: (resp: any) => {
          this.visible = true;
        this.isValidating = false;
          if (resp.isSuccess) {
            this.validate.emit({
              msg: resp.message,
              step: 2,
              success: true,
            });
          } else {
            this.msgError = resp.message;
          }
        },
        error: (err: any) => {
          console.error(err.error);
          this.visible = true;
        this.isValidating = false;
          this.msgError =
             'No se pudo validar el código, intenta de nuevo';
        },
      });
  }

  validateOTPBlock() {
    this.appServices.blockAccount(this.clientNumber,this.info,true,this.otp).subscribe({
      next: (resp: any) => {
        this.visible = true;
        this.isValidating = false;
        if (resp.isSuccess) {
          this.validate.emit({
            success: true,
          });
        } else {
          this.msgError = resp.request;
        }
      },
      error: (error: any) => {
        this.visible = true;
        this.isValidating = false;
          this.msgError =
            'No se pudo validar el código, intenta de nuevo';
      }
    })
  }

  validateOTPActivate(type:number,dataSend:string) {
    this.appServices.activateAccount(this.clientNumber,this.info,true,this.otp,dataSend,type).subscribe({
      next: (resp: any) => {
        this.visible = true;
        this.isValidating = false;
        if (resp.isSuccess) {
          this.validate.emit({
            success: true,
          });
        } else {
          this.msgError = resp.request;
        }
      },
      error: (error: any) => {
        this.visible = true;
        this.isValidating = false;
          this.msgError =
          'No se pudo validar el código, intenta de nuevo';
      }
    })
  }
}


